import { render, staticRenderFns } from "./CustomerDropdown.vue?vue&type=template&id=5f039832&scoped=true&"
import script from "./CustomerDropdown.vue?vue&type=script&lang=js&"
export * from "./CustomerDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f039832",
  null
  
)

export default component.exports